import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const FieldLabel = ({ children, lg = 2 }) => (
    <Grid item lg={lg}>
        <Typography>{children}</Typography>
    </Grid>
);

FieldLabel.propTypes = {
    children: PropTypes.node,
    lg: PropTypes.number
};

export { FieldLabel };
